import { render, staticRenderFns } from "./campaign-component.vue?vue&type=template&id=79af83b2&scoped=true&"
import script from "./campaign-component.vue?vue&type=script&lang=js&"
export * from "./campaign-component.vue?vue&type=script&lang=js&"
import style0 from "./campaign-component.vue?vue&type=style&index=0&id=79af83b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af83b2",
  null
  
)

export default component.exports